import { registerPlugin } from '@capacitor/core';

export interface Version {
  version: string;
}

/**
 * Workaround plugin that re-sends the `LoadingActivity_Dismiss` broadcast to tear down `IONCAMRLoadingActivity`.
 * See: https://github.com/ionic-team/capacitor-camera/issues/55
 */
export interface CameraLoadingDismissPlugin {
  getVersion(): Promise<Version>;
  dismiss(): Promise<void>;
}

export const CAMERA_LOADING_DISMISS_PLUGIN_NAME = 'CameraLoadingDismiss';

export const cameraLoadingDismissPlugin =
  registerPlugin<CameraLoadingDismissPlugin>(
    CAMERA_LOADING_DISMISS_PLUGIN_NAME,
  );
